import React, { useState } from 'react'
import { Loader, Modal } from 'rsuite'

import { AddToEventButton as MyButton } from '../../Activity/ActivityStyledComponents'
import { colors } from '../../Styles/common-styles'
import styles from '../../AdminPanel/styles'
import { OpenBin, SuccessArrow, ErrorCross } from '../../Icons'

const deleteUser = async (token, userId, setStatusOfDeletion,
  setLoading, updateUsersTable) => {
  const url = 'https://us-central1-taito-training.cloudfunctions.net/deleteUserById'
  // const url = 'http://localhost:5001/taito-training/us-central1/deleteUserById'
  setLoading(true)
  const httpHeaders = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: token
  }
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: httpHeaders,
      body: JSON.stringify({ uid: userId })
    })
    const res = await response.json()
    if (res.status === 'ok') {
      updateUsersTable()
    }
    setLoading(false)
    setStatusOfDeletion(res)
  } catch (err) {
    console.error(err)
  }
}

const SimpleUser = ({
  loading, userData, updateUsersTable,
  setModalVisible, setLoading, token
}) => {
  const [statusOfDeletion, setStatusOfDeletion] = useState(false)
  const userName = userData.displayName
  const userId = userData.uid

  return (
    <>
      {!statusOfDeletion.status
        ? <>
          {loading && <Loader backdrop size='lg' content='loading...' vertical />}
          <Modal.Header>
            <Modal.Title style={styles.modalTitle1}>
              Do you want to delete user '{userName}' ?
            </Modal.Title>
            <Modal.Title style={styles.modalTitle2}>
              Once deleted you can't get him back
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={styles.modalBody}>
            {!loading && <OpenBin stroke={colors.purpleMain} />}
          </Modal.Body>
          <Modal.Footer style={styles.modalFooter}>
            <MyButton cancel onClick={() => setModalVisible(false)}>No, thanks </MyButton>
            <MyButton
              delete
              onClick={() => {
                deleteUser(token, userId, setStatusOfDeletion, setLoading, updateUsersTable)
              }}>Just do it </MyButton>
          </Modal.Footer>
        </>
        : <>
          {statusOfDeletion.status === 'ok'
            ? <>
              <Modal.Header>
                <Modal.Title style={styles.modalTitle1}>
                  '{userName}' was succesfully deleted
                </Modal.Title>
                <Modal.Title style={styles.modalTitle2}>
                  {statusOfDeletion.text}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body style={styles.modalBody}>
                <SuccessArrow stroke={colors.green} />
              </Modal.Body>
              <Modal.Footer style={styles.modalFooter}>
                <MyButton
                  reverse
                  onClick={() => setModalVisible(false)}
                >Close</MyButton>
              </Modal.Footer>
            </>
            : <>
              <Modal.Header>
                <Modal.Title style={styles.modalTitle1}>
                  Something went wrong
                </Modal.Title>
                <Modal.Title style={styles.modalTitle2}>
                  {statusOfDeletion.text}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body style={styles.modalBody}>
                <ErrorCross stroke={colors.errorRed} />
              </Modal.Body>
              <Modal.Footer style={styles.modalFooter}>
                <MyButton reverse onClick={() => setModalVisible(false)}>Close</MyButton>
              </Modal.Footer>
            </>}
        </>}
    </>
  )
}

export default SimpleUser
